/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsticketactive2Inputs */

const en_ticketsticketactive2 = /** @type {(inputs: Ticketsticketactive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valid`)
};

const de_ticketsticketactive2 = /** @type {(inputs: Ticketsticketactive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gültig`)
};

/**
* | output |
* | --- |
* | "Valid" |
*
* @param {Ticketsticketactive2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsticketactive2 = /** @type {((inputs?: Ticketsticketactive2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsticketactive2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsticketactive2(inputs)
	return de_ticketsticketactive2(inputs)
});
export { ticketsticketactive2 as "ticketsTicketActive" }